import React from 'react';
export function IncomePotential() {
  return <section className="py-20 px-4 bg-black text-white" aria-label="Potencial de ingresos con pisos epoxi" data-id="element-117">
      <div className="max-w-4xl mx-auto text-center" data-id="element-118">
        <h2 className="text-3xl md:text-5xl font-black mb-4 text-amber-500 uppercase tracking-tight" data-id="element-119">
          ¿Cuánto puede dejar un trabajo de epoxi?
        </h2>
        <p className="text-gray-400 text-lg mb-12 max-w-2xl mx-auto" data-id="element-120">
          Números reales. Sin exageraciones.
        </p>

        {/* Income examples */}
        <ul className="grid md:grid-cols-3 gap-4 mb-12 list-none p-0" data-id="element-121">
          {[{
          tipo: 'Cochera',
          metros: '~20 m²',
          ingreso: '$400.000 – $600.000',
          detalle: 'Trabajo de 1 día. Materiales: ~$120.000.'
        }, {
          tipo: 'Local comercial',
          metros: '~50 m²',
          ingreso: '$800.000 – $1.200.000',
          detalle: 'Trabajo de 2–3 días. Alta demanda.'
        }, {
          tipo: 'Galpón industrial',
          metros: '~150 m²',
          ingreso: '$2.000.000 – $3.000.000',
          detalle: 'Trabajo de 4–5 días. Margen alto.'
        }].map((item, i) => <li key={i} className="bg-[#1a1a1a] p-6 rounded-xl border border-amber-900/40 text-left" data-id="element-122">
              <p className="text-amber-500 font-bold text-lg mb-1" data-id="element-123">
                {item.tipo}
              </p>
              <p className="text-gray-500 text-sm mb-3" data-id="element-124">{item.metros}</p>
              <p className="text-white font-black text-2xl mb-2" data-id="element-125">
                {item.ingreso}
              </p>
              <p className="text-gray-400 text-sm" data-id="element-126">{item.detalle}</p>
            </li>)}
        </ul>

        {/* Emotional Phrase */}
        <blockquote className="mb-16 px-4" data-id="element-127">
          <p className="text-xl md:text-2xl font-bold text-white text-center max-w-3xl mx-auto leading-relaxed border-l-4 border-amber-500 pl-6 py-2 bg-amber-900/10 rounded-r-lg" data-id="element-128">
            Mientras muchos trabajan todo el mes para llegar justo, una cochera
            puede dejar eso en un solo trabajo.
          </p>
        </blockquote>

        {/* Cost of NOT knowing block */}
        <div className="bg-[#111] border border-red-900/30 rounded-2xl p-8 mb-8 text-left md:text-center shadow-xl" data-id="element-129">
          <h3 className="text-2xl md:text-3xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-130">
            ¿Cuánto cuesta NO saber?
          </h3>
          <p className="text-gray-300 text-lg md:text-xl mb-6 max-w-2xl mx-auto" data-id="element-131">
            Un error en obra puede costarte{' '}
            <span className="text-red-400 font-bold" data-id="element-132">$50.000 o más</span> en
            materiales perdidos. El Mega Pack cuesta{' '}
            <span className="text-amber-400 font-bold" data-id="element-133">$29.990</span> y te
            enseña a evitarlos desde el primer trabajo.
          </p>

          {/* Comparison */}
          <ul className="grid md:grid-cols-3 gap-4 text-sm mt-8 list-none p-0" data-id="element-134">
            {[{
            label: 'Mega Pack completo',
            value: '$29.990',
            color: 'text-amber-400',
            bg: 'bg-amber-900/10 border-amber-900/40'
          }, {
            label: 'Un error en materiales',
            value: '~$50.000+',
            color: 'text-red-400',
            bg: 'bg-red-900/10 border-red-900/20'
          }, {
            label: 'Perder un cliente por mal trabajo',
            value: 'Incalculable',
            color: 'text-gray-400',
            bg: 'bg-[#1a1a1a] border-gray-800'
          }].map((item, i) => <li key={i} className={`p-5 rounded-xl border ${item.bg}`} data-id="element-135">
                <p className="text-gray-400 mb-2 font-medium" data-id="element-136">{item.label}</p>
                <p className={`font-black text-2xl ${item.color}`} data-id="element-137">
                  {item.value}
                </p>
              </li>)}
          </ul>
        </div>

        <p className="text-gray-500 text-sm mt-6" data-id="element-138">
          * Los valores son estimativos y varían según zona, materiales y tipo
          de trabajo.
        </p>
      </div>
    </section>;
}